export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0B4F6C] mb-4">
            About CareJoint Physiotherapy Clinic
          </h2>
          <div className="w-20 h-1 bg-[#14B8A6] mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <p className="text-base text-gray-700 leading-relaxed">
              At CareJoint, we believe in a holistic approach to healing, combining expert clinical care with genuine compassion. Founded in 2021 by Dr. Sadati Mukiibi Nsambya, our mission is to not just treat your pain, but to empower you to achieve long-term physical freedom and a better quality of life.
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              Our team of dedicated professionals uses evidence-based techniques and cutting-edge technology to deliver personalized treatment plans tailored to your unique needs. We are committed to helping you regain your strength, mobility, and confidence.
            </p>
            <div className="flex flex-wrap gap-8 pt-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-[#14B8A6]/10 rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-2xl text-[#14B8A6]"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-[#0B4F6C]">3+</div>
                  <div className="text-sm text-gray-600 whitespace-nowrap">Years Experience</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-[#14B8A6]/10 rounded-full flex items-center justify-center">
                  <i className="ri-user-heart-line text-2xl text-[#14B8A6]"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-[#0B4F6C]">500+</div>
                  <div className="text-sm text-gray-600 whitespace-nowrap">Happy Patients</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-[#14B8A6]/10 rounded-full flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-2xl text-[#14B8A6]"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-[#0B4F6C]">15+</div>
                  <div className="text-sm text-gray-600 whitespace-nowrap">Specialized Services</div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-[#F0F9FF] rounded-2xl p-8 shadow-lg">
              <div className="flex items-start space-x-6">
                <div className="w-32 h-32 flex-shrink-0">
                  <img
                    src="https://static.readdy.ai/image/d4c6fcf69c7d885228da6e53459f8742/5b3ff81edc874446f494af0a2b8a0d21.jpeg"
                    alt="Dr. Sadati Mukiibi Nsambya"
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-[#0B4F6C] mb-2">
                    Dr. Sadati Mukiibi Nsambya
                  </h3>
                  <p className="text-sm text-[#14B8A6] font-medium mb-3">Founder &amp; Lead Physiotherapist</p>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    With extensive experience in rehabilitation and pain management, Dr. Sadati founded CareJoint to provide compassionate, evidence-based care that transforms lives. His holistic approach combines clinical expertise with a deep understanding of each patient's unique journey.
                  </p>
                </div>
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#14B8A6]/10 rounded-full -z-10"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-[#0B4F6C]/5 rounded-full -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}